import React, { useEffect, useState } from 'react'
import useActivityLoggerStore from 'modules/slot_booking_loggers/store';
import ActivityLoggerHeader from 'modules/slot_booking_loggers/ActivityLoggerHeader'
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import PaginationDiv from 'modules/pagination/PaginationDiv';
import ActivityLoggerFilter from 'modules/slot_booking_loggers/ActivityLoggerFilter';
import ActivityLoggerTable from 'modules/slot_booking_loggers/ActivityLoggerTable';

function SlotBookingLoggers() {

  const {activityData,activityLoading, fetchActivityData}= useActivityLoggerStore();
  const [page, newPage]= useState(1);
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageNumber=searchParams.get("pageNumber")
  const start=searchParams.get("sd");
  const end= searchParams.get("ed");

  useEffect(()=>{
    navigate(`/slot-booking-loggers?pageNumber=${page}&sd=${start}&ed=${end}`)
  },[page])


  useEffect(() => {
    const trimmedStart = start.trim();
    const trimmedEnd = end.trim();
    let startDate = new Date(trimmedStart).getTime();
    let endDate = new Date(trimmedEnd).getTime();
    fetchActivityData(startDate, endDate,pageNumber);
  }, [start, end, pageNumber]);

  return (
    <div>
      <ActivityLoggerHeader />
      <ActivityLoggerFilter />
      <ActivityLoggerTable data={activityData.logs} isLoading={activityLoading} />
      {activityData?.count?(
        <PaginationDiv
        paginationData={{
          pageCount: activityData?.count ? Math.ceil(activityData?.count / 10) : 1,
          page: page,
        }}
        newPage={newPage}
      />
      ) : (
        <></>
      )}
    </div>
  )
}

export default SlotBookingLoggers
